import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, white} from '/theme/color/on.color';
import {blue} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: indent,
    backgroundColor: white,
    paddingHorizontal: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    borderTopWidth: Platform.OS === 'web' ? 0 : 1,
    borderTopColor: cloudLight,
  },
  focusedOutline: {
    borderWidth: 2,
    borderColor: blue,
    borderRadius: 4,
  },
});
